import React from 'react';
import styled, { keyframes } from 'styled-components';

// Section container
const Section = styled.section`
  text-align: center;
  padding: 2rem 1rem;
`;

// Title at the top
const Title = styled.h2`
  font-size: 1.5rem;
  margin-bottom: 2rem;
`;

// Scrolling animation: de 0 → -50% de la piste
const scroll = keyframes`
  0%   { transform: translateX(0); }
  100% { transform: translateX(-50%); }
`;

// Container qui masque le débordement
const LogosContainer = styled.div`
  position: relative;
  overflow: hidden;
`;

// Inner wrapper animé sur mobile
const AnimatedLogos = styled.div`
  display: flex;
  gap: 2rem;
  width: 200%;                     /* 2× la largeur pour dupliquer le contenu */
  animation: ${scroll} 15s linear infinite; /* durée ajustée à 12s */

  @media (min-width: 769px) {
    animation: none;               /* plus de scroll sur desktop */
    width: auto;                   /* redeviens largeur auto hors mobile */
  }
`;

// Wrapper pour chaque logo
const LogoWrapper = styled.div`
  flex: 0 0 auto;
`;

// Image du logo
const Logo = styled.img`
  max-width: 100px;
  height: auto;
`;

// Données par défaut de vos partenaires
const defaultPartners = [
  { name: 'Recharge', logo: '/image.png' },
  { name: 'Moni', logo: 'https://allo.monisnap.com/logo-blue.svg' },
  { name: 'TC', logo: 'https://tse2.mm.bing.net/th/id/OIP.bLLYzmD_MJDiyT1kbJ6WowHaBA?cb=thfvnextfalcon2&rs=1&pid=ImgDetMain&o=7&rm=3' },
  { name: 'DUncle', logo: 'https://cdn.dundle.com/resources/images/themes/logos/dundle.com-2023/dundle-logo-light-theme-default.svg' },
  { name: 'PaySafe', logo: 'https://tse4.mm.bing.net/th/id/OIP.GfijY0qedhgbgeqBGYoe7wHaBQ?cb=thfvnextfalcon2&rs=1&pid=ImgDetMain&o=7&rm=3' },
  { name: 'Neosurf', logo: 'https://www.neosurf.com/wp-content/uploads/logo-neosurf-white-tagline-1.png' },
  { name: 'PCS', logo: 'https://banque.meilleurtaux.com/images/logo/logo_mypcs.png' },
  { name: 'GOOGLEPLAY', logo: 'https://kstatic.googleusercontent.com/files/8c7f5d41791f61c4a99edc6d8ce30a2107fdaf89c46b2471aceeea4d59a1aaa092318b2bba7729c18b3c2b31100709779151cda100f5bee525e0a1e586db927a' }
];

/**
 * Partner component  
 * @param {{ partners?: { name: string; logo: string; }[] }} props
 */
const Partner = ({ partners = defaultPartners }) => {
  // Duplication pour un scroll continu sans saut
  const looped = [...partners, ...partners];

  return (
    <Section>
      <Title>Ils nous font confiance</Title>

      <LogosContainer className="container text-center">
        <AnimatedLogos>
          {looped.map((p, i) => (
            <LogoWrapper key={`${p.name}-${i}`}>
              <Logo src={p.logo} alt={p.name} />
            </LogoWrapper>
          ))}
        </AnimatedLogos>
      </LogosContainer>
    </Section>
  );
};

export default Partner;
